import { render, staticRenderFns } from "./z-tooltip.vue?vue&type=template&id=5c2c50a2&scoped=true&"
import script from "./z-tooltip.vue?vue&type=script&lang=js&"
export * from "./z-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./z-tooltip.vue?vue&type=style&index=0&id=5c2c50a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2c50a2",
  null
  
)

export default component.exports